/*
 * MessageActionContext
 *
 * markdown 自定义代码块（如 FileListBlock 渲染的「保存为模板」「分享」按钮）
 * 没有像 message.attachments → AttachmentRenderer 那样的 onAction 上行链路，
 * 但它们的副作用同样应该是"在当前会话里发一条消息让 AI 接着处理"，
 * 而不是直接调后端接口。
 *
 * ChatPanel 在最外层 Provider 里把上下文里 send 注入下来，块内直接消费。
 * 避免一层层 prop drill 到 MessageContent → FileListBlock。
 */
import { createContext, useContext } from 'react'

export interface MessageActionContextValue {
  /** 往当前会话追加一条用户消息（等价于用户在输入框输入并点发送） */
  sendMessage: (text: string) => void
}

export const MessageActionContext = createContext<
  MessageActionContextValue | undefined
>(undefined)

export function useMessageAction(): MessageActionContextValue | undefined {
  return useContext(MessageActionContext)
}
